// Node Module Imports
import React from 'react'

import { Link } from 'gatsby'
import styled from 'styled-components'

// Component Imports
import { above, colors } from '../../style/design-system'
import UmaLogoRectangle from '../core/uma-logo-rect'
import NavPrimary from '../navigation/NavPrimary'
import SearchBar from '../navigation/SearchBar'

// Style Imports

const NavDesktop = ({ className }) => (
  <nav className={`${className} nav-main py-5`}>
    <div className="container-fluid nav-main-wrapper d-flex justify-content-between align-items-center">
      <Link to="/" className="logo"><UmaLogoRectangle /></Link>
      <NavPrimary />
      <SearchBar />
    </div>
  </nav>
)

export default styled(NavDesktop)`
  background-color: ${colors.umaLightGray};
  display: none;
  
  ${above.lg`
    display: block;
  `}

  a {
    display: inline-block;
  }

  .logo {
    font-size: 0;
  }

  .nav-main-wrapper {
    [class^="SearchBar"] {
      ${above.lg`
        width: 20vw;
      `}
    }
  }
`
